module.exports = __webpack_public_path__ + "static/traditional-menu-056af36f522bd36434b7de9224755bdf.jpg";